const AdminSpaces = () => {
  return (
    "admin spaces"
  )
}
export default AdminSpaces;